<template>
  <v-row dense>
    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-form ref="formBusca">
            <v-row dense>
              <!-- <v-col cols="12" sm="12" md="3">
                <v-text-field label="CNPJ"></v-text-field>
              </v-col>-->

              <v-col cols="12" sm="12" md="2">
                <v-select
                  label="Ativa"
                  v-model="filtro.ativo"
                  :rules="[rules.required]"
                  :items="['Sim', 'Não']"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-select
                  label="Segmento"
                  :items="['2', '4']"
                  :rules="[rules.required]"
                  v-model="filtro.segmento"
                  small-chips
                >
                  <template v-slot:selection="{ item }">
                    <span>{{ item }}</span>

                    <v-icon>
                      {{
                      item === '2' ? 'mdi-motorbike' : 'mdi-car-hatchback'
                      }}
                    </v-icon>
                  </template>
                  <template v-slot:item="{ item }">
                    <span>{{ item }}</span>

                    <v-icon>
                      {{
                      item === '2' ? 'mdi-motorbike' : 'mdi-car-hatchback'
                      }}
                    </v-icon>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-row justify="center">
                  <v-btn
                    outlined
                    color="blue darken-2"
                    rounded
                    dark
                    depressed
                    small
                    @click="buscar()"
                  >
                    <v-icon left>mdi-magnify</v-icon>Buscar
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-data-table
            id="table"
            :search="table.selected"
            :headers="table.headers"
            :items="table.dados"
          >
            <template v-slot:top>
              <v-row dense>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="pesquisar"
                    v-model="table.selected"
                    append-icon="mdi-magnify"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.seguimento="{ item }">
              <v-icon>
                {{
                item.seguimento === '2' ? 'mdi-motorbike' : 'mdi-car-hatchback'
                }}
              </v-icon>
            </template>
            <template v-slot:item.ativo="{ item }">
              <v-tooltip v-if="$ability.can('Editar', 'Empresas')" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="transparent"
                    v-on="on"
                    small
                    fab
                    depressed
                    @click="alterar_status(item)"
                  >
                    <v-icon
                      :color="item.ativo ? 'green' : 'red'"
                      :title="item.ativo ? 'Ativa' : 'Desativada'"
                      class="pr-0 pl-0"
                    >{{ item.ativo ? 'mdi-check' : 'mdi-close' }}</v-icon>
                  </v-btn>
                </template>
                <span>Ativa/Desativar Empresa</span>
              </v-tooltip>
              <v-btn
                v-else
                color="transparent"
                v-on="on"
                small
                fab
                depressed
              >
                <v-icon
                  :color="item.ativo ? 'green' : 'red'"
                  :title="item.ativo ? 'Ativa' : 'Desativada'"
                  class="pr-0 pl-0"
                >{{ item.ativo ? 'mdi-check' : 'mdi-close' }}</v-icon>
              </v-btn>
            </template>

            <template v-slot:item.acoes="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="$ability.can('Editar','Empresas')"
                    color="transparent"
                    small
                    fab
                    depressed
                    v-on="on"
                    @click="$refs.dialogAltEmp.show(true, 'editar', item)"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar Empresa</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>

    <DialogEmpresa ref="dialogEmp" @saved="buscar()" />
    <DialogEmpresa ref="dialogAltEmp" @saved="buscar()" />
  </v-row>
</template>

<script>
import rules from "@/utils/rules";
import Empresa from "@/services/empresa";
export default {
  name: "Empresas",
  components: {
    DialogEmpresa: () => import("./components/DialogEmpresa")
  },
  data() {
    return {
      rules: rules,
      filtro: {
        ativo: "Sim",
        segmento: "2"
      },
      table: {
        selected: "",
        headers: [
          { text: "Cnpj", value: "cnpj" },
          { text: "Apelido", value: "apelido" },
          { text: "Nome", value: "nome" },
          { text: "Estado", value: "estado" },
          { text: "Cidade", value: "cidade" },
          { text: "Contato", value: "contato" },
          { text: "Status", value: "ativo" },
          { text: "Seguimento", value: "seguimento" },
          { text: "Ações", value: "acoes" }
        ],
        dados: []
      },
      rules: rules
    };
  },
  methods: {
    async buscar() {
      if (this.$refs.formBusca.validate()) {
        try {
          const dados = await new Empresa().listAll(this.filtro);
          this.table.dados = dados;
          if (dados.length === 0) {
            this.$toast.warning("Nada foi encontrado");
          }
        } catch (error) {
          this.$toast.error(error);
        }
      }
    },
    exibir() {
      this.$refs.dialogEmp.show(true);
    },
    alterar_status(item) {
      if (item.ativo) {
        this.$swal.confirm("Deseja desativar empresa?").then(() => {
          this.update(item, false);
        });
      } else {
        this.$swal.confirm("Deseja ativar empresa? ").then(() => {
          this.update(item, true);
        });
      }
    },
    async update(item, value) {
      try {
        const dados = await new Empresa().updateAtivo(item.cnpj, value);
      } catch (error) {
        this.$toast.error(error);
      } finally {
        this.buscar();
      }
    }
  }
};
</script>

